import React from 'react';
import ReviewSection from '../components/ReviewSection';

export const Reviews = () => {
    return (
        <div>
            <ReviewSection />
        </div>
    );
};
